/**
 * CargaSaraivaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaSaraiva} from '@/model/resource/CargaSaraiva'

/* TODO: review generated class */
@HttpExclude()
export class CargaSaraivaCollection extends PageCollection<CargaSaraiva> {
  constructor() {
    super(CargaSaraiva)
  }

  queryAsPage() {
    return this.listCargaSaraiva()
  }

  async listCargaSaraiva() {
    return await Request.get(`/admin/carga-saraiva`, {params: this.params})
      .name('listCargaSaraiva')
      .as(this)
      .getResponse()
  }

  async listCsvCargaSaraiva() {
    return await Request.get(`/admin/carga-saraiva/csv`, {params: this.params})
      .name('listCsvCargaSaraiva')
      .as(this)
      .getResponse()
  }
}
